/*
 *
 * AccountPage reducer
 *
 */

import {
  DEFAULT_ACTION,
  PATCH_ACCOUNT_REQUEST,
  PUT_ACCOUNT_SUCCESS,
  PUT_ACCOUNT_FAILURE,
} from './constants';

// currentPasswordError: the server's 422 message for the current_password field.
// savedCount: bumps on each successful save so the form can clear pending edits.
const initialState = { currentPasswordError: null, savedCount: 0 };

const currentPasswordMessage = (error) => {
  const raw = error?.errors?.current_password;
  const detail = Array.isArray(raw) ? raw[0] : raw;
  if (detail) {
    return /^current password/i.test(detail) ? detail : `Current password ${detail}`;
  }
  if (error?.statusCode === 422 && /current password/i.test(error?.error || '')) {
    return error.error;
  }
  return null;
};

function accountPageReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case PATCH_ACCOUNT_REQUEST:
      return { ...state, currentPasswordError: null };
    case PUT_ACCOUNT_SUCCESS:
      return { ...state, currentPasswordError: null, savedCount: state.savedCount + 1 };
    case PUT_ACCOUNT_FAILURE:
      return { ...state, currentPasswordError: currentPasswordMessage(action.payload) };
    default:
      return state;
  }
}

export default accountPageReducer;
